/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFactoryIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-factory"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.33 22.32Q3.2 22.32 2.44 21.56Q1.68 20.8 1.68 19.68L1.68 11.53Q1.68 10.72 2.11 10.06Q2.55 9.4 3.27 9.07L7.47 7.3Q8.13 7.03 8.72 7.4Q9.32 7.78 9.32 8.5L9.32 8.53L12.5 7.25Q13.15 6.97 13.74 7.36Q14.32 7.75 14.32 8.47L14.32 9.68L22.32 9.68L22.32 19.68Q22.32 20.8 21.56 21.56Q20.8 22.32 19.68 22.32ZM10.68 18.32L13.32 18.32L13.32 13.68L10.68 13.68ZM6.67 18.32L9.32 18.32L9.32 13.68L6.67 13.68ZM14.68 18.32L17.32 18.32L17.32 13.68L14.68 13.68ZM22.13 8.18L16.93 8.18L17.57 2.85Q17.63 2.35 18.01 2.01Q18.4 1.68 18.9 1.68L20.1 1.68Q20.6 1.68 20.99 2Q21.38 2.33 21.43 2.83Z" fill={color} />
    </svg>
  );
}
